import { useMemo } from 'react'
import styles from './PercentInput.module.css'
import { percentageBoundary } from './PercentageBoundary'

interface NonEditableInputProps {
  value: number | null
  label: string
  limit?: number | null
}

// Function to check if a label should be treated as multiline
const isMultilineLabel = (label: string) => {
  return label?.length > 20
}

// Function to handle long labels, formatting them for better display
const formatLongLabel = (label: string) => {
  return label || ''
}

export const NonEditablePercentInput = ({
  value,
  label,
  limit,
}: NonEditableInputProps) => {
  // Format the label for display
  const formattedLabel = useMemo(() => formatLongLabel(label), [label])
  const isMultiline = useMemo(() => isMultilineLabel(label), [label])

  const inputClassName = percentageBoundary(value, limit)
  const displayValue = value !== null ? value : ''

  return (
    <div className={styles.percentInputContainer}>
      <label
        className={`${styles.percentInputLabel} ${
          isMultiline ? styles.multilineLabel : ''
        }`}
      >
        {formattedLabel}
      </label>
      <div className={inputClassName}>
        <input
          value={displayValue}
          className={styles.percentInput}
          type="number"
          disabled
        />
      </div>
    </div>
  )
}
